var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolhalondrina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.422,
    height: 35.13,
    viewBox: "0 0 206.422 35.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_227",
    "data-name": "Caminho 227",
    d: "M12.109,0H5.61V35.13H21.172V29.9H12.109Z",
    transform: "translate(14.098)",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_228",
    "data-name": "Caminho 228",
    d: "M0,35.13H6.464V19.989h7.764v-5.34H6.464V5.234H16.476V0H0Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_229",
    "data-name": "Caminho 229",
    d: "M59.572,13.024,54.513,2.38H52.3V20.366h2.74V9.055l5.34,11.312h1.9V2.38h-2.7Z",
    transform: "translate(131.428 5.981)",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_230",
    "data-name": "Caminho 230",
    d: "M33.411,2.38H29.09V20.366H33.9c3.337,0,5.024-2.881,5.024-8.607v-.738C38.926,5.261,37.1,2.38,33.411,2.38Zm2.389,9.2a17.916,17.916,0,0,1-.351,4c-.386,1.37-.808,2.073-1.9,2.073H32.287V5.05h.808c1.019,0,1.475.7,1.967,2.143a12.4,12.4,0,0,1,.738,3.935Z",
    transform: "translate(73.102 5.981)",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_231",
    "data-name": "Caminho 231",
    d: "M62.586,2.38H59.811L55.42,20.366h2.7l.984-4.321h3.724l.984,4.321h3.337ZM59.671,13.446,60.97,7.4l1.3,6.042Z",
    transform: "translate(139.269 5.981)",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_232",
    "data-name": "Caminho 232",
    d: "M49.171,2.38H44.85V20.366h4.813c3.513,0,5.024-2.881,5.024-8.607v-.738C54.686,5.261,52.86,2.38,49.171,2.38Zm2.248,9.2a17.917,17.917,0,0,1-.351,4c-.386,1.37-.808,2.073-1.9,2.073H48.117V5.05h.773c1.019,0,1.475.7,1.932,2.143a12.3,12.3,0,0,1,.562,3.935Z",
    transform: "translate(112.707 5.981)",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_233",
    "data-name": "Caminho 233",
    d: "M48.727,13.024,43.668,2.38H41.49V20.366h2.7V9.055l5.34,11.312h1.9V2.38h-2.7Z",
    transform: "translate(104.263 5.981)",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_234",
    "data-name": "Caminho 234",
    d: "M43.39,2.31a4.567,4.567,0,0,0-4.18,2.635,13,13,0,0,0-1.194,6.218v1.019a12.682,12.682,0,0,0,1.265,6.077,4.567,4.567,0,0,0,8.22,0,12.822,12.822,0,0,0,1.054-6.148v-.948a13.63,13.63,0,0,0-1.23-6.183A4.391,4.391,0,0,0,43.39,2.31Zm2.038,9.45a19.743,19.743,0,0,1-.386,4.216c-.351,1.546-.773,2.319-1.792,2.319s-1.616-.738-1.9-2.213a26.134,26.134,0,0,1-.141-4.321v-.386a22.236,22.236,0,0,1,.316-4.216c.316-1.546.738-2.319,1.862-2.319s1.546.773,1.862,2.319a22.238,22.238,0,0,1,.246,4.216Z",
    transform: "translate(95.478 5.805)",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_235",
    "data-name": "Caminho 235",
    d: "M53.937,10.811q2.74-.386,2.74-3.513V6.244c0-2.564-1.159-3.864-3.513-3.864H48V20.366h3.267v-8.08h.386c1.054,0,1.475,1.089,1.827,3.232a31.619,31.619,0,0,1,.281,4.848h3.232a26.068,26.068,0,0,0-.457-5.621,5.059,5.059,0,0,0-2.6-3.935Zm-.492-3.2c0,1.37-.351,2.073-1.651,2.073H51.3V4.944h.667c1.194,0,1.475.738,1.475,2.178Z",
    transform: "translate(120.622 5.981)",
    fill: "#000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_236",
    "data-name": "Caminho 236",
    d: "M35.517,12.6h3.618V9.9H35.517V5.05H40.26V2.38H32.25V20.366h8.361V17.7H35.517Z",
    transform: "translate(81.043 5.981)",
    fill: "#000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_245",
    "data-name": "Ret\\xE2ngulo 245",
    width: 2.951,
    height: 17.986,
    transform: "translate(179.232 8.361)",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_237",
    "data-name": "Caminho 237",
    d: "M29.026,2.38,24.6,20.366h2.74l.984-4.321h3.724l.984,4.321h3.513L31.977,2.38Zm0,11.066L30.256,7.4l1.3,6.042Z",
    transform: "translate(61.819 5.981)",
    fill: "#000"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_238",
    "data-name": "Caminho 238",
    d: "M12.96,20.366h3.232V12.6h3.935V9.9H16.192V5.05h5.059V2.38H12.96Z",
    transform: "translate(32.568 5.981)",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_239",
    "data-name": "Caminho 239",
    d: "M39.047,2.38H35.78V20.366h7.834V17.7H39.047Z",
    transform: "translate(89.914 5.981)",
    fill: "#000"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_240",
    "data-name": "Caminho 240",
    d: "M27.642,9.863H24.867V2.38H21.6V20.366h3.267V12.638h2.775v7.729h3.232V2.38H27.642Z",
    transform: "translate(54.28 5.981)",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_241",
    "data-name": "Caminho 241",
    d: "M20.9,2.31a4.567,4.567,0,0,0-4.18,2.635,13,13,0,0,0-1.265,6.218v1.019a12.682,12.682,0,0,0,1.265,6.077,4.567,4.567,0,0,0,8.22,0,12.822,12.822,0,0,0,1.265-6.148v-.948A13.63,13.63,0,0,0,24.98,4.98,4.391,4.391,0,0,0,20.9,2.31Zm1.932,9.45a19.743,19.743,0,0,1-.316,4.11c-.351,1.546-.773,2.319-1.792,2.319s-1.616-.738-1.9-2.213a26.136,26.136,0,0,1-.211-4.216v-.386a22.237,22.237,0,0,1,.246-4.216c.316-1.546.738-2.319,1.862-2.319s1.546.773,1.862,2.319a22.236,22.236,0,0,1,.246,4.216Z",
    transform: "translate(38.816 5.805)",
    fill: "#000"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_242",
    "data-name": "Caminho 242",
    d: "M22.107,2.38H18.84V20.366h8.15V17.7H22.107Z",
    transform: "translate(47.344 5.981)",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolhalondrina);
export default __webpack_public_path__ + "static/media/folhalondrina.818d4b35c30492a367f3ca97cb213ed4.svg";
export { ForwardRef as ReactComponent };